import { render, staticRenderFns } from "./AdminLoginPage.vue?vue&type=template&id=08acaedd&scoped=true"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js"
import style0 from "./AdminLoginPage.vue?vue&type=style&index=0&id=08acaedd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acaedd",
  null
  
)

export default component.exports